import { useState } from 'react';
import axios from 'axios';
import { encrypt } from '../../Encypt/xor';
import { Modal } from 'antd';

const ActionButton = ({ chatId, location, userData, lastEvent, setLastEvent, eventType }) => {
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null);

  const buttonLabel = eventType === "clock_in" ? "Clock In" : "Clock Out";

  const handleClick = async () => {
    if (!chatId || !location || !userData) {
      showErrorModal("Not enough data to send. Contact IT.");
      return;
    }

    setLoading(true);
    setStatus(null);

    const payload = {
      event_type: eventType,
      latitude: location.latitude,
      longitude: location.longitude,
      auth_token: JSON.stringify(chatId),
    };

    try {
      const encryptedPayload = encrypt(JSON.stringify(payload));
      console.log(encryptedPayload);
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/clock`,
        { clock_json: encryptedPayload }
      );
      console.log("✅ Response from server:", response.data);

      setStatus("success");
      setLastEvent(eventType); // Update state
    } catch (error) {
      console.error("❌ Error:", error);
      setStatus("error");
      showErrorModal("There was an error sending events. Please try again later or contact your IT department.");
    } finally {
      setLoading(false);
    }
  };

  const showErrorModal = (message) => {
    Modal.error({
      title: 'Error Clock-In/Out',
      content: message,
      okText: 'OK',
    });
  };

  return (
    <div>
      <button
        className={`btn btn-primary ${eventType === "clock_in" ? "clock_in" : "clock_out"}`}
        onClick={handleClick}
        disabled={loading}
      >
        {loading ? "Updating..." : buttonLabel}
      </button>
    </div>
  );
};

export default ActionButton;
